import AdminHeader from "components/Headers/AdminHeader";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Badge,
  Container,
  Row,
  Col,
  Card,
  Input,
  CardHeader,
  CardBody,
  UncontrolledTooltip,
  UncontrolledPopover,
  PopoverBody,
  CardTitle,
} from "reactstrap";
import Select, { components } from "react-select";
import {
  getBatchList,
  getActiveCourseNameList,
  updateBatchById,
} from "action/batch";
import { batchList } from "constants/batch";
import { useDispatch, useSelector } from "react-redux";
import { getInstructorList } from "action/instructor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import {
  fixedWidthCustomStyle,
  DEFAULT_RECORDS_PER_PAGE,
} from "constants/CommonConstants";
import { BATCH_STATUS_OPTIONS, STATUS_BADGE_COLORS } from "components/constant";
import { formatDate } from "components/CommonComponents/CommonFunctions";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { showAlert } from "components/CommonComponents/CommonFunctions";
import moment from "moment";
import { getInstructorBatchList } from "action/batch";

function BatchListing() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const dispatch = useDispatch();
  const { notify } = useContext(NotificationContext);
  const role = authData?.role;
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [filterState, setFilterState] = useState({
    batchId: "",
    sessionName: "",
    courseName: null,
    Instructor: null,
    searchStatus: null,
    batchDate: [null, null],
    registrationDate: [null, null],
    filterParams: [],
  });
  const [isCancellingStatus, setIsCancellingStatus] = useState();
  const [listState, setListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
    showLoaderOnClick: false,
  });
  const [copiedLink, setCopiedLink] = useState(null);

  const batchListData = useSelector((state) => state.batch.batchList);
  const courseNameListData = useSelector(
    (state) => state.batch.activeCourseNameList,
  );
  const instructorListData = useSelector(
    (state) => state.instructor.instructorList,
  );

  const hideForTrainer = role === "TRAINER";

  useEffect(() => {
    if (role !== "TRAINER") {
      getInstructorList(dispatch);
    }
    getActiveCourseNameList(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (role === "TRAINER") {
      getInstructorBatchList(dispatch, pageNum, filterState.filterParams);
    } else {
      getBatchList(dispatch, pageNum, filterState.filterParams);
    }

    return () => {
      dispatch({ type: batchList, payload: {} });
    };
  }, [dispatch, pageNum, filterState.filterParams]);

  useEffect(() => {
    if (batchListData?.code === 200) {
      setListState({
        isLoading: false,
        error: "",
        noRecords: batchListData?.data?.Batches?.length === 0,
        showLoaderOnClick: false,
      });
    } else if (batchListData?.code || batchListData?.message) {
      setListState({
        isLoading: false,
        error:
          batchListData?.message ||
          "Failed to load batch list! Please try again.",
        noRecords: false,
        showLoaderOnClick: false,
      });
    }
  }, [batchListData]);

  const instructorOptions =
    instructorListData?.data?.trainers?.map((trainer) => ({
      label: trainer.user?.fullName,
      value: trainer.ID,
    })) || [];

  const courseOptions =
    courseNameListData?.data?.map((course) => ({
      value: course.ID,
      label: course.courseName,
    })) || [];

  const batchListingData =
    batchListData?.data?.Batches?.map((batch, index) => ({
      id: batch.ID,
      srNo:
        (pageNum - 1) * (batchListData?.data?.noOfRecordsPerPage || 10) +
        index +
        1,
      batchId: batch.code,
      courseName: batch.courses?.courseName || "—",
      sessionName: batch.name,
      startDate: batch.batchStartDate,
      endDate: batch.batchEndDate,
      registrationStartDate: batch.registrationStartDate,
      registrationEndDate: batch.registrationEndDate,
      createdBy: batch.createdBy || "—",
      startTime: batch.startTime,
      endTime: batch.endTime,
      enrolledUserCount: batch.enrolledUserCount || 0,
      availableSeats: (batch.maxParticipants || 0) - (batch.enrolledCount || 0),
      offlineTrainingCenter: batch.trainingCenters?.name || "—",
      minParticipant: batch.minParticipants,
      maxParticipant: batch.maxParticipants,
      duration: batch.duration || "—",
      instructors:
        batch.trainers?.map((trainer) =>
          `${trainer.user?.firstName || ""} ${trainer.user?.lastName || ""}`.trim(),
        ) || [],
      status: batch.status,
      batchEnrollmentURLTrainee: batch.batchEnrollmentURLTrainee || "",
      batchEnrollmentURLChannelPartner:
        batch.batchEnrollmentURLChannelPartner || "",
    })) || [];

  const buildFilterParams = () => {
    const filters = [];

    if (filterState.batchId?.trim()) {
      filters.push({
        field: "Code",
        condition: "like",
        filterValues: [filterState.batchId.trim()],
      });
    }

    if (filterState.sessionName?.trim()) {
      filters.push({
        field: "Name",
        condition: "like",
        filterValues: [filterState.sessionName.trim()],
      });
    }

    if (filterState.courseName?.value) {
      filters.push({
        field: "CourseID",
        condition: "eq",
        filterValues: [String(filterState.courseName.value)],
      });
    }

    if (filterState.Instructor?.value) {
      filters.push({
        field: "TrainerName",
        condition: "eq",
        filterValues: [filterState.Instructor.label],
      });
    }

    if (filterState.searchStatus?.value) {
      filters.push({
        field: "Status",
        condition: "eq",
        filterValues: [filterState.searchStatus.value],
      });
    }

    if (filterState.batchDate[0]) {
      if (filterState.batchDate[1]) {
        filters.push({
          field: "BatchStartDate",
          condition: "btw",
          filterValues: [
            formatDate(filterState.batchDate[0]),
            formatDate(filterState.batchDate[1]),
          ],
        });
      } else {
        filters.push({
          field: "BatchStartDate",
          condition: "eq",
          filterValues: [formatDate(filterState.batchDate[0])],
        });
      }
    }

    if (filterState.registrationDate[0]) {
      if (filterState.registrationDate[1]) {
        filters.push({
          field: "RegistrationStartDate",
          condition: "btw",
          filterValues: [
            formatDate(filterState.registrationDate[0]),
            formatDate(filterState.registrationDate[1]),
          ],
        });
      } else {
        filters.push({
          field: "RegistrationStartDate",
          condition: "eq",
          filterValues: [formatDate(filterState.registrationDate[0])],
        });
      }
    }

    return filters.length ? JSON.stringify(filters) : [];
  };

  const handleSearch = () => {
    const newFilters = buildFilterParams();

    if (
      JSON.stringify(filterState.filterParams) !== JSON.stringify(newFilters)
    ) {
      setListState((prev) => ({
        ...prev,
        isLoading: true,
        showLoaderOnClick: true,
      }));
      setFilterState((prev) => ({
        ...prev,
        filterParams: newFilters,
      }));

      if (pageNum !== 1) {
        setPageNum(1);
      }
    }
  };

  const handleClear = () => {
    setListState((prev) => ({
      ...prev,
      isLoading: true,
    }));

    setFilterState({
      batchId: "",
      sessionName: "",
      courseName: null,
      Instructor: null,
      searchStatus: null,
      batchDate: [null, null],
      registrationDate: [null, null],
      filterParams: [],
    });

    if (pageNum !== 1) setPageNum(1);
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={STATUS_BADGE_COLORS[props.data.value] || "secondary"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={STATUS_BADGE_COLORS[props.data.value] || "secondary"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  // const closeCancelModal = () => {
  //   setCancelBatch({
  //     isOpen: false,
  //     batchId: null,
  //   });
  // };

  // const handleCancelBatch = async (batchId, remark) => {
  //   try {
  //     setListState((prev) => ({
  //       ...prev,
  //       isLoading: true,
  //     }));
  //     const payload = {
  //       status: "CANCELLED",
  //       cancellationRemark: remark,
  //     };

  //     const res = await updateBatchById(batchId, payload);

  //     if (res?.code === 200) {
  //       closeCancelModal();
  //       notify("success", res?.message || "Batch cancelled successfully.");
  //       getBatchList(dispatch, pageNum, filterState.filterParams);
  //     } else {
  //       const message = Array.isArray(res?.message)
  //         ? res.message
  //             .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
  //             .join(", ")
  //         : res?.message || "Failed to cancel batch.";

  //       notify("danger", message);
  //     }
  //   } catch (error) {
  //     notify(
  //       "danger",
  //       error?.message || "Failed to cancel batch. Please try again.",
  //     );
  //   } finally {
  //     setListState((prev) => ({
  //       ...prev,
  //       isLoading: true,
  //     }));
  //   }
  // };

  const handleCancelClick = (batchId) => {
    showAlert({
      title: "Cancel Batch",
      message: "Are you sure you want to cancel this batch?",
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "No",
      showInput: true,
      inputPlaceholder: "Reason for cancellation",
      inputRequired: true,
      inputErrorMsg: "Please enter reason for cancellation",
      onConfirm: async (remark, closeAlert) => {
        closeAlert();
        try {
          setIsCancellingStatus(true);
          const payload = {
            status: "CANCELLED",
            cancellationRemark: remark,
          };

          const res = await updateBatchById(batchId, payload);

          if (res?.code === 200) {
            notify("success", res?.message || "Batch cancelled successfully.");

            getBatchList(dispatch, pageNum, filterState.filterParams);
          } else {
            const message = Array.isArray(res?.message)
              ? res.message
                  .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
                  .join(", ")
              : res?.message || "Failed to cancel batch.";

            notify("danger", message);
          }
        } catch (error) {
          notify(
            "danger",
            error?.message || "Failed to cancel batch. Please try again.",
          );
        } finally {
          setIsCancellingStatus(false);
        }
      },
    });
  };

  const handleNavigateToEnrollment = (e, rowData) => {
    e.stopPropagation();

    const encodedId = urlEncodedId(rowData.id);
    const params = new URLSearchParams();

    params.set("tab", "enrollment");

    const state = {
      batchId: encodedId,
    };

    if (rowData.sessionName) {
      state.batchName = rowData.sessionName;
    }

    navigate(
      role === "TRAINER"
        ? `/instructor/batch/${encodedId}/details?${params.toString()}`
        : role === "SUPER_ADMIN"
          ? `/super-admin/batch/${encodedId}/details?${params.toString()}`
          : `/admin/batch/${encodedId}/details?${params.toString()}`,
      { state },
    );
  };

  const handleOnRowClick = (rowData) => {
    const encodedId = urlEncodedId(rowData.id);

    navigate(
      role === "TRAINER"
        ? `/instructor/batch/${encodedId}/details`
        : role === "SUPER_ADMIN"
          ? `/super-admin/batch/${encodedId}/details`
          : `/admin/batch/${encodedId}/details`,
    );
  };

  const handleCopyEnrollmentLink = async (url, batchId, type) => {
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);

      setCopiedLink({
        batchId,
        type,
      });

      setTimeout(() => {
        setCopiedLink(null);
      }, 2000);
    } catch (error) {
      notify("warning", "Failed to copy enrollment link");
    }
  };

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
      centerAlign: true,
      minWidth: 60,
      maxWidth: 70,
    },
    // {
    //   Header: "Batch Code",
    //   accessor: "batchId",
    //   minWidth: 190,
    //   maxWidth: 190,
    //   Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    // },
    {
      Header: "Batch Name",
      accessor: "sessionName",
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    },
    {
      Header: "Course Name",
      accessor: "courseName",
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    },
   
    {
      Header: "Offline Training Center",
      accessor: "offlineTrainingCenter",
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => <div className="text-wrapper">{value || "—"}</div>,
    },
    ...(!hideForTrainer
      ? [
          {
            Header: "Instructors",
            accessor: "instructors",
            minWidth: 200,
            maxWidth: 200,
            Cell: ({ value, row }) => {
              const trainers = (value || []).filter((trainer) =>
                trainer?.trim(),
              );

              if (!trainers.length) {
                return "—";
              }

              const visibleTrainers = trainers.slice(0, 2);
              const remainingCount = trainers.length - 2;
              const { id } = row.original;
              const trainerPopoverId = `trainer-${id}`;

              return (
                <div className="text-wrapper">
                  {visibleTrainers.map((trainer, index) => (
                    <div className="trainer-name" key={index}>
                      <div className="trainer-row">
                        <span className="trainer-bullet">•</span>
                        <span className="trainer-text">{trainer}</span>
                      </div>

                      {index === 1 && remainingCount > 0 && (
                        <>
                          <div className="trainer-count">
                            <Badge
                              id={trainerPopoverId}
                              color="primary"
                              pill
                              className="cursor-pointer ml-3"
                            >
                              +{remainingCount}
                            </Badge>
                          </div>

                          <UncontrolledPopover
                            target={trainerPopoverId}
                            trigger="hover"
                            placement="top"
                          >
                            <PopoverBody>
                              <div className="trainer-popover-list">
                                {trainers.map((t, tIndex) => (
                                  <div key={tIndex}>• {t}</div>
                                ))}
                              </div>
                            </PopoverBody>
                          </UncontrolledPopover>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              );
            },
          },
        ]
      : []),
    {
      Header: "Registration Dates",
      centerAlign: true,
      minWidth: 150,
      maxWidth: 150,
      Cell: ({ row }) => {
        const { registrationStartDate, registrationEndDate } = row.original;

        if (!registrationStartDate || !registrationEndDate) return "—";

        return (
          <div className="text-wrapper">
            <div>{registrationStartDate}</div>
            <div className="font-weight-bold ml-2">to</div>
            <div>{registrationEndDate}</div>
          </div>
        );
      },
    },
    {
      Header: "Batch Dates",
      centerAlign: true,
      minWidth: 125,
      maxWidth: 125,
      Cell: ({ row }) => {
        const { startDate, endDate } = row.original;

        if (!startDate || !endDate) return "—";

        return (
          <div className="text-wrapper">
            <div>{startDate}</div>
            <div className="font-weight-bold text-center">to</div>
            <div>{endDate}</div>
          </div>
        );
      },
    },

    {
      Header: "Daily Timing",
      centerAlign: true,
      accessor: "timing",
      minWidth: 150,
      maxWidth: 150,
      Cell: ({ row }) => {
        const { startTime, endTime } = row.original;

        if (!startTime || !endTime) return "—";

        return (
          <div className="text-wrapper">
            <div>{startTime}</div>
            <div className="font-weight-bold ml-1">to</div>
            <div>{endTime}</div>
          </div>
        );
      },
    },
    // {
    //   Header: "Duration",
    //   accessor: "duration",
    //   Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    // },
    // {
    //   Header: "Enrolled",
    //   accessor: "enrolledCount",
    //   minWidth: 150,
    //   maxWidth: 150,
    //   rightAlign: true,
    // },

    // {
    //   Header: "Capacity",
    //   accessor: "capacity",
    //   minWidth: 150,
    //   maxWidth: 150,
    //   Cell: ({ row }) => {
    //     const { minParticipant, maxParticipant } = row.original;

    //     return (
    //       <div className="text-wrapper">
    //         {minParticipant && maxParticipant
    //           ? `${minParticipant} to ${maxParticipant}`
    //           : "—"}
    //       </div>
    //     );
    //   },
    //   rightAlign: true,
    // },
    ...(!hideForTrainer
      ? []
      : [
          {
            Header: "Enrollments",
            accessor: "enrolledCount",
            minWidth: 90,
            maxWidth: 90,
            centerAlign: true,
            Cell: ({ row }) => (
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  color="link"
                  className="p-0"
                  onClick={(e) => handleNavigateToEnrollment(e, row.original)}
                  title="View Enrollments"
                >
                  <i className="fa fa-eye" />
                </Button>
                <span className="mr-2">
                  {row.original.enrolledUserCount || 0}
                </span>
              </div>
            ),
          },
        ]),
    {
      Header: "Enrollment Link",
      accessor: "BatchEnrollmentURL",
      minWidth: 250,
      maxWidth: 250,
      Cell: ({ row }) => {
        const batchId = row.original.id;

        const traineeURL = row.original.batchEnrollmentURLTrainee;

        const channelPartnerURL = row.original.batchEnrollmentURLChannelPartner;

        const traineeCopied =
          copiedLink?.batchId === batchId && copiedLink?.type === "trainee";

        const channelPartnerCopied =
          copiedLink?.batchId === batchId &&
          copiedLink?.type === "channelPartner";

        return (
          <div className="d-flex flex-column align-items-start">
            <div className="mb-1 text-wrapper">
              <span className="mr-2">Trainee:</span>

              {traineeCopied ? (
                <span className="text-success font-weight-bold">
                  <i className="fa fa-check mr-1" />
                  Link Copied!
                </span>
              ) : (
                <Button
                  color="link"
                  className="p-0 xxs-text"
                  disabled={!traineeURL}
                  onClick={(e) => {
                    e.stopPropagation();

                    handleCopyEnrollmentLink(traineeURL, batchId, "trainee");
                  }}
                  title="Copy Trainee Enrollment Link"
                >
                  <i className="fa fa-link mr-1" />
                  Copy Link
                </Button>
              )}
            </div>

            <div className="text-wrapper">
              <span className="mr-2">Channel Partner:</span>

              {channelPartnerCopied ? (
                <span className="text-success font-weight-bold">
                  <i className="fa fa-check mr-1" />
                  Link Copied!
                </span>
              ) : (
                <Button
                  color="link"
                  className="p-0 xxs-text"
                  disabled={!channelPartnerURL}
                  onClick={(e) => {
                    e.stopPropagation();

                    handleCopyEnrollmentLink(
                      channelPartnerURL,
                      batchId,
                      "channelPartner",
                    );
                  }}
                  title="Copy Channel Partner Enrollment Link"
                >
                  <i className="fa fa-link mr-1" />
                  Copy Link
                </Button>
              )}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      minWidth: 110,
      maxWidth: 110,
      centerAlign: true,
      Cell: ({ value }) => {
        const statusLabel =
          BATCH_STATUS_OPTIONS.find((option) => option.value === value)
            ?.label || value;

        return (
          <Badge color={STATUS_BADGE_COLORS[value] || "secondary"} pill>
            {statusLabel}
          </Badge>
        );
      },
    },
    {
      Header: "Updated By",
      accessor: "createdBy",
      centerAlign:true,
      minWidth: 120,
      maxWidth: 140,
      Cell: ({ value }) => <div className="text-wrapper">{value || "—"}</div>,
    },
    ...(!hideForTrainer
      ? [
          {
            Header: "Actions",
            disableSortBy: true,
            Cell: ({ row }) => {
              const id = row.original.id;
              const encodedId = urlEncodedId(row.original.id);
              const isCancel = row.original.status !== "CANCELLED";
              const { startDate } = row.original;
              const isBatchStarted = moment(
                startDate,
                "DD MMM YYYY",
              ).isSameOrBefore(moment(), "day");

              return (
                <div className="d-flex">
                  <Button
                    className="btn-link d-flex align-items-center p-0"
                    id={`view${encodedId}`}
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        role === "SUPER_ADMIN"
                          ? `/super-admin/batch/${encodedId}/details`
                          : `/admin/batch/${encodedId}/details`,
                      );
                    }}
                  >
                    <i className="fas fa-eye mr-1 table-action-primary" />
                  </Button>

                  <UncontrolledTooltip target={`view${encodedId}`}>
                    View
                  </UncontrolledTooltip>

                  <Button
                    className="btn-link d-flex align-items-center p-0"
                    id={`enrolled${encodedId}`}
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        role === "SUPER_ADMIN"
                          ? `/super-admin/batch/${encodedId}/details?tab=enrollment`
                          : `/admin/batch/${encodedId}/details?tab=enrollment`,
                      );
                    }}
                  >
                    <i className="fa fa-users mr-1 table-action-primary" />
                    <span className="mr-2">
                      {row.original.enrolledUserCount || 0}
                    </span>
                  </Button>

                  <UncontrolledTooltip target={`enrolled${encodedId}`}>
                    Enrolled Trainees
                  </UncontrolledTooltip>
                  {!isBatchStarted && isCancel && (
                    <>
                      <Button
                        className="btn-link d-flex align-items-center p-0"
                        id={`edit${encodedId}`}
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(
                            role === "SUPER_ADMIN"
                              ? `/super-admin/batch/edit/${encodedId}`
                              : `/admin/batch/edit/${encodedId}`,
                          );
                        }}
                      >
                        <i className="fas fa-edit mr-1 table-action-info" />
                      </Button>

                      <UncontrolledTooltip target={`edit${encodedId}`}>
                        Edit
                      </UncontrolledTooltip>
                    </>
                  )}

                  {isCancel && <span className="mx-1 text-muted">|</span>}

                  {isCancel && (
                    <>
                      <Button
                        className="btn-link d-flex align-items-center p-0 ml-2"
                        id={`cancel${encodedId}`}
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCancelClick(id);
                        }}
                      >
                        <i className="fas fa-times table-action-danger" />
                      </Button>

                      <UncontrolledTooltip target={`cancel${encodedId}`}>
                        Cancel Batch
                      </UncontrolledTooltip>
                    </>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
  ];
  return (
    <>
      <AdminHeader />
      {isCancellingStatus && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              Updating status... Please wait.
            </div>
          </div>
        </div>
      )}
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              {/* head */}
              <CardHeader className="d-flex justify-content-between align-items-center">
                <CardTitle tag="h3" className="mb-0 text-default">
                  Batches
                </CardTitle>
                {!hideForTrainer && (
                  <Button
                    className="btn-deep-blue"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? "/super-admin/batch/add-batch"
                          : "/admin/batch/add-batch",
                        {
                          state: { mode: "add" },
                        },
                      )
                    }
                  >
                    <i className="fa fa-plus mr-1" />
                    Batch
                  </Button>
                )}
              </CardHeader>

              {/* body */}
              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    {/* <Input
                      type="text"
                      placeholder="Search by batch code"
                      className="mr-2 mb-2 filter-input-large"
                      value={filterState.batchId}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          batchId: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    /> */}

                    <Input
                      type="text"
                      placeholder="Search by batch name"
                      className="mr-2 mb-2 filter-input-large"
                      value={filterState.sessionName}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          sessionName: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={courseOptions}
                      placeholder="Select course name"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      value={filterState.courseName}
                      onChange={(selected) =>
                        setFilterState((prev) => ({
                          ...prev,
                          courseName: selected,
                        }))
                      }
                    />

                    {!hideForTrainer && (
                      <Select
                        className="mr-2 mb-2 filter-select"
                        options={instructorOptions}
                        placeholder="Select instructor"
                        value={filterState.Instructor}
                        onChange={(selected) =>
                          setFilterState((prev) => ({
                            ...prev,
                            Instructor: selected,
                          }))
                        }
                        classNamePrefix="react-select"
                        styles={fixedWidthCustomStyle()}
                      />
                    )}

                    <DatePicker
                      selected={filterState.registrationDate[0]}
                      onChange={(dates) =>
                        setFilterState((prev) => ({
                          ...prev,
                          registrationDate: dates,
                        }))
                      }
                      startDate={filterState.registrationDate[0]}
                      endDate={filterState.registrationDate[1]}
                      selectsRange
                      isClearable={!!filterState.registrationDate[0]}
                      placeholderText="Select registration date or range"
                      className="form-control mr-2 mb-2 filter-input-large"
                      dateFormat="dd-MMM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      calendarClassName="custom-calendar"
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(e) => {
                        if (e.key !== "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />

                    <DatePicker
                      selected={filterState.batchDate[0]}
                      onChange={(dates) =>
                        setFilterState((prev) => ({
                          ...prev,
                          batchDate: dates,
                        }))
                      }
                      startDate={filterState.batchDate[0]}
                      endDate={filterState.batchDate[1]}
                      selectsRange
                      isClearable={!!filterState.batchDate[0]}
                      placeholderText="Select batch date or range"
                      className="form-control mr-2 mb-2 filter-input-large"
                      dateFormat="dd-MMM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      calendarClassName="custom-calendar"
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(e) => {
                        if (e.key !== "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={BATCH_STATUS_OPTIONS}
                      placeholder="Select status"
                      value={filterState.searchStatus}
                      onChange={(selected) =>
                        setFilterState((prev) => ({
                          ...prev,
                          searchStatus: selected,
                        }))
                      }
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      onKeyDown={handleKeyDown}
                      // isClearable
                    />

                    <Button
                      color="default"
                      onClick={handleSearch}
                      disabled={listState.showLoaderOnClick}
                      className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${
                        listState.showLoaderOnClick ? "search-btn" : ""
                      }`}
                    >
                      {listState.showLoaderOnClick ? (
                        <i className="fa fa-spinner fa-spin mr-1" />
                      ) : (
                        <>
                          <i className="fa fa-search mr-1" />
                          Search
                        </>
                      )}
                    </Button>

                    {Object.keys(filterState.filterParams).length > 0 && (
                      <Button
                        color="default"
                        className="mb-2 filter-btn btn-simple btn-deep-blue"
                        onClick={handleClear}
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>
                <div className="mt-2 mb-3 mx-1">
                  {batchListData?.data?.totalRecords > 0 ? (
                    <>
                      {filterState.filterParams.length > 0 ? (
                        <span className="total-records">
                          Showing {batchListData?.data?.totalFilteredRecords} of{" "}
                          {batchListData?.data?.totalRecords} Records
                        </span>
                      ) : (
                        <span className="total-records">
                          Total Records : {batchListData?.data?.totalRecords}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>

                {listState.isLoading ? (
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                ) : listState.error ? (
                  <div className="loaderContainer error-style">
                    <div className="error-icon">
                      <i class="fa-solid fa-circle-exclamation"></i>
                    </div>
                    <span>{listState.error}</span>
                  </div>
                ) : listState.noRecords ? (
                  <div className="loaderContainer empty-style">
                    <div className="empty-icon">
                      <i class="fa-solid fa-circle-info"></i>
                    </div>
                    <span>No batches found.</span>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <CommonTable
                      columns={columns}
                      data={batchListingData}
                      defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                      activePage={pageNum}
                      setPageNum={setPageNum}
                      totalPages={Math.ceil(
                        (batchListData?.data?.totalFilteredRecords || 0) /
                          (batchListData?.data?.noOfRecordsPerPage ||
                            DEFAULT_RECORDS_PER_PAGE),
                      )}
                      showPaginationBottom={true}
                      rowClick={(row) => handleOnRowClick(row)}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* <AddDocumentModal
        isOpen={cancelBatch.isOpen}
        toggle={closeCancelModal}
        title="Cancel Batch"
        label="Cancellation Remark"
        onSave={(remark) => handleCancelBatch(cancelBatch.batchId, remark)}
      /> */}
    </>
  );
}

export default BatchListing;
